import { TransformPlayerConfig } from './transform-player-config';

/**
 * Due to patent conformance we may have to toggle the usage of the Bola ABR rule if applicable for the used player tech.
 */
export const addBolaAbr: TransformPlayerConfig = (partialBuilderConfig, playerConfig) => {
  return {
    ...playerConfig,
    enableBolaAbr: playerConfig.enableBolaAbr ?? partialBuilderConfig.remoteConfig.settings?.abr?.bola ?? false,
  };
};
